import React, { useEffect, useState } from 'react';
import styles from './client-info-paje.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getClientsDb, toggleSaveActivityListBD } from '../../firebase';
import { addClientsRedux, toggleSaveActivityListRedux } from '../../store/slices/clientsSlice';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import PopupEditClient from '../../components/PopupEditClient/PopupEditClient';
import AddClientNotes from '../../components/AddClientNotes/AddClientNotes';

export default function ClientInfoPage() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  let { clientId } = useParams();
  const [popup, setPopup] = useState(false);
  const [loaderPage, setLoaderPage] = useState(false);
  const [copyClientIdTrue, setCopyClientIdTrue] = useState(false);

  const clients = useSelector((state) => state.clients.clients);

  // Получаєм клієнта по id
  const client = clients.length
    ? clients.filter((client) => client.client_id === clientId)[0]
    : false;

  useEffect(() => {
    if (!clients.length) {
      setLoaderPage(true);
      const getClients = async () => {
        const clients = await getClientsDb();
        dispatch(addClientsRedux(clients));
        // console.log('clients ===', clients);
        setLoaderPage(false);
      };
      getClients();
    }
  }, []);

  const copyClientId = (client_id) => {
    navigator.clipboard
      .writeText(client_id)
      .then(() => {
        setCopyClientIdTrue(client_id);
        setTimeout(() => {
          setCopyClientIdTrue(false);
        }, 700);
      })
      .catch((err) => {
        alert('Не вдалося Скопіювати!');
        console.log(err);
      });
  };

  const renderParticipationGroups = (client) => {
    const participationGroupsKeys = Object.keys(client.participationGroups);

    return participationGroupsKeys.map((itemKey) => {
      return (
        <div
          className={styles.accessGroups_item}
          key={client.participationGroups[itemKey].group_id}>
          {client.participationGroups[itemKey].groupName}
          {client.participationGroups[itemKey].accessGroup && (
            <div className={styles.accessGroups_item_active} />
          )}
        </div>
      );
    });
  };

  const toggleSaveActivityList = async (client) => {
    setLoaderPage(true);

    const isToggle = window.confirm('Змінити?');

    if (isToggle) {
      if (client.isAddLoginWebList) {
        const isToggle = await toggleSaveActivityListBD(client.client_id, false);
        if (isToggle) {
          dispatch(toggleSaveActivityListRedux({ client_id: client.client_id, isSave: false }));
        }
        setLoaderPage(false);
      } else {
        const isToggle = await toggleSaveActivityListBD(client.client_id, true);

        if (isToggle) {
          dispatch(toggleSaveActivityListRedux({ client_id: client.client_id, isSave: true }));
        }
        setLoaderPage(false);
      }
    } else {
      setLoaderPage(false);
    }
  };

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <div className={styles.header_wrapper}>
        <div className={styles.header_back_btn} onClick={() => navigate(-1)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
      </div>
      {/* -------------- /Header ------------------------ */}
      {client ? (
        <div className={styles.content_wrapper}>
          <div className={styles.info_wrapper}>
            <svg
              onClick={() => setPopup(true)}
              className={styles.edit_icon_svg}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 72 72"
              width="64px"
              height="64px">
              <path d="M38.406 22.234l11.36 11.36L28.784 54.576l-12.876 4.307c-1.725.577-3.367-1.065-2.791-2.79l4.307-12.876L38.406 22.234zM41.234 19.406l5.234-5.234c1.562-1.562 4.095-1.562 5.657 0l5.703 5.703c1.562 1.562 1.562 4.095 0 5.657l-5.234 5.234L41.234 19.406z" />
            </svg>

            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Дата реєстрації:</div>
              <div className={styles.info_item}>
                {client.date} <span className={styles.info_item_time}>{client.date_time}</span>
              </div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Ім'я:</div>
              <div className={styles.info_item}>{client.name ? client.name : '--'}</div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Прізвище:</div>
              <div className={styles.info_item}>{client.surname ? client.surname : '--'}</div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Клієнт-ID:</div>
              <div
                className={styles.info_item + ' ' + styles.info_item_id}
                onClick={() => copyClientId(client.client_id)}>
                {copyClientIdTrue === client.client_id && (
                  <div className={styles.alertCopyTrue}>Скопійовано!</div>
                )}
                {client.client_id}
              </div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>З реклами:</div>
              {client.fromAdvertising ? (
                <div className={styles.info_item_fromAdvertising}>Так</div>
              ) : (
                <div className={styles.info_item}>Ні</div>
              )}
            </div>
            <div className={styles.info_item_wrapper}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                id="phone"
                fill="#888d91">
                <path d="M13.216 8.064c-.382-4.394-4.966-6.55-5.16-6.638a.974.974 0 0 0-.582-.078c-5.292.878-6.088 3.958-6.12 4.086a.99.99 0 0 0 .02.54c6.312 19.584 19.43 23.214 23.742 24.408.332.092.606.166.814.234a.99.99 0 0 0 .722-.042c.132-.06 3.248-1.528 4.01-6.316a.997.997 0 0 0-.096-.612c-.068-.132-1.698-3.234-6.218-4.33a.977.977 0 0 0-.884.21c-1.426 1.218-3.396 2.516-4.246 2.65-5.698-2.786-8.88-8.132-9-9.146-.07-.57 1.236-2.572 2.738-4.2a.998.998 0 0 0 .26-.766z"></path>
              </svg>
              <div className={styles.info_item_title}>Телефон:</div>
              {client.tel ? (
                <a className={styles.info_item_link} href={'tel:+' + client.tel}>
                  {client.tel}
                </a>
              ) : (
                <div>--</div>
              )}
            </div>
            <div className={styles.info_item_wrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20px" height="20">
                <path
                  fill="#fff"
                  d="M24,5C21.361,5,13.33,5,8.89,9.054C6.246,11.688,5,15.494,5,21v3c0,5.506,1.246,9.312,3.921,11.976 c1.332,1.215,3.148,2.186,5.368,2.857L15,39.047v5.328C15,45,15.181,45,15.241,45c0.123,0,0.32-0.039,0.694-0.371 c0.09-0.089,0.75-0.803,3.96-4.399l0.324-0.363l0.485,0.031C21.779,39.965,22.888,40,24,40c2.639,0,10.67,0,15.11-4.055 C41.753,33.311,43,29.505,43,24v-3c0-5.506-1.246-9.312-3.921-11.976C34.67,5,26.639,5,24,5z"></path>
                <path
                  fill="#7e57c2"
                  d="M33.451 28.854c-1.111-.936-1.624-1.219-3.158-2.14C29.654 26.331 28.68 26 28.169 26c-.349 0-.767.267-1.023.523C26.49 27.179 26.275 28 25.125 28c-1.125 0-3.09-1.145-4.5-2.625C19.145 23.965 18 22 18 20.875c0-1.15.806-1.38 1.462-2.037C19.718 18.583 20 18.165 20 17.816c0-.511-.331-1.47-.714-2.109-.921-1.535-1.203-2.048-2.14-3.158-.317-.376-.678-.548-1.056-.549-.639-.001-1.478.316-2.046.739-.854.637-1.747 1.504-1.986 2.584-.032.147-.051.295-.057.443-.046 1.125.396 2.267.873 3.234 1.123 2.279 2.609 4.485 4.226 6.455.517.63 1.08 1.216 1.663 1.782.566.582 1.152 1.145 1.782 1.663 1.97 1.617 4.176 3.103 6.455 4.226.958.472 2.086.906 3.2.874.159-.005.318-.023.477-.058 1.08-.238 1.947-1.132 2.584-1.986.423-.568.74-1.406.739-2.046C33.999 29.532 33.827 29.171 33.451 28.854zM34 24c-.552 0-1-.448-1-1v-1c0-4.962-4.038-9-9-9-.552 0-1-.448-1-1s.448-1 1-1c6.065 0 11 4.935 11 11v1C35 23.552 34.552 24 34 24zM27.858 22c-.444 0-.85-.298-.967-.748-.274-1.051-1.094-1.872-2.141-2.142-.535-.139-.856-.684-.718-1.219.138-.534.682-.855 1.219-.718 1.748.453 3.118 1.822 3.575 3.574.139.535-.181 1.08-.715 1.22C28.026 21.989 27.941 22 27.858 22z"></path>
                <path
                  fill="#7e57c2"
                  d="M31,23c-0.552,0-1-0.448-1-1c0-3.188-2.494-5.818-5.678-5.986c-0.552-0.029-0.975-0.5-0.946-1.051 c0.029-0.552,0.508-0.976,1.051-0.946C28.674,14.241,32,17.748,32,22C32,22.552,31.552,23,31,23z"></path>
                <path
                  fill="#7e57c2"
                  d="M24,4C19.5,4,12.488,4.414,8.216,8.316C5.196,11.323,4,15.541,4,21c0,0.452-0.002,0.956,0.002,1.5 C3.998,23.043,4,23.547,4,23.999c0,5.459,1.196,9.677,4.216,12.684c1.626,1.485,3.654,2.462,5.784,3.106v4.586 C14,45.971,15.049,46,15.241,46h0.009c0.494-0.002,0.921-0.244,1.349-0.624c0.161-0.143,2.02-2.215,4.042-4.481 C21.845,40.972,22.989,41,23.999,41c0,0,0,0,0,0s0,0,0,0c4.5,0,11.511-0.415,15.784-4.317c3.019-3.006,4.216-7.225,4.216-12.684 c0-0.452,0.002-0.956-0.002-1.5c0.004-0.544,0.002-1.047,0.002-1.5c0-5.459-1.196-9.677-4.216-12.684C35.511,4.414,28.5,4,24,4z M41,23.651l0,0.348c0,4.906-1.045,8.249-3.286,10.512C33.832,38,26.437,38,23.999,38c-0.742,0-1.946-0.001-3.367-0.1 C20.237,38.344,16,43.083,16,43.083V37.22c-2.104-0.505-4.183-1.333-5.714-2.708C8.045,32.248,7,28.905,7,23.999l0-0.348 c0-0.351-0.001-0.73,0.002-1.173C6.999,22.078,6.999,21.7,7,21.348L7,21c0-4.906,1.045-8.249,3.286-10.512 C14.167,6.999,21.563,6.999,24,6.999c2.437,0,9.832,0,13.713,3.489c2.242,2.263,3.286,5.606,3.286,10.512l0,0.348 c0,0.351,0.001,0.73-0.002,1.173C41,22.922,41,23.3,41,23.651z"></path>
              </svg>
              <div className={styles.info_item_title}>Viber:</div>
              {client.tel ? (
                <a
                  className={styles.info_item_link}
                  href={`viber://contact?number=%2B${client.tel}`}>
                  Перейти в Viber
                </a>
              ) : (
                <div>--</div>
              )}
            </div>
            <div className={styles.info_item_wrapper}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                enableBackground="new 0 0 100 100"
                viewBox="0 0 100 100"
                id="telegram"
                height="20"
                width="20">
                <path
                  id="Layer_2"
                  fill="#1b92d1"
                  d="M88.723,12.142C76.419,17.238,23.661,39.091,9.084,45.047c-9.776,3.815-4.053,7.392-4.053,7.392
 s8.345,2.861,15.499,5.007c7.153,2.146,10.968-0.238,10.968-0.238l33.62-22.652c11.922-8.107,9.061-1.431,6.199,1.431
 c-6.199,6.2-16.452,15.975-25.036,23.844c-3.815,3.338-1.908,6.199-0.238,7.63c6.199,5.246,23.129,15.976,24.082,16.691
 c5.037,3.566,14.945,8.699,16.452-2.146c0,0,5.961-37.435,5.961-37.435c1.908-12.637,3.815-24.321,4.053-27.659
 C97.307,8.804,88.723,12.142,88.723,12.142z"></path>
              </svg>
              <div className={styles.info_item_title}>Telegram:</div>
              {client.tel ? (
                <a className={styles.info_item_link} href={`https://t.me/+${client.tel}`}>
                  Перейти в Telegram
                </a>
              ) : (
                <div>--</div>
              )}
            </div>
          </div>
          <div className={styles.info_wrapper}>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Дата народження (рік-міс-чис):</div>
              <div className={styles.info_item}>
                {client.userBirthday ? client.userBirthday : '--'}
              </div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Зріст:</div>
              <div className={styles.info_item}>
                {client.userHeight ? client.userHeight + ' ' + 'см' : '--'}
              </div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Вага:</div>
              <div className={styles.info_item}>
                {client.userWeight ? client.userWeight + ' ' + 'кг' : '--'}
              </div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Ціль:</div>
              <div className={styles.info_item}>{client.goal ? client.goal.text : '--'}</div>
            </div>
            <div className={styles.info_item_wrapper}>
              <div className={styles.info_item_title}>Активність:</div>
              <div className={styles.info_item}>
                {client.activity ? client.activity.text : '--'}
              </div>
            </div>
          </div>

          <div className={styles.active_control_wrapper}>
            <div>Чи зберігати деталі активності</div>
            <div
              onClick={() => toggleSaveActivityList(client)}
              className={
                client.isAddLoginWebList
                  ? styles.active_control_btn + ' ' + styles.active_control_btn_active
                  : styles.active_control_btn
              }></div>
          </div>
          {Object.keys(client.participationGroups).length ? (
            <>
              Участь в супроводі:
              <div className={styles.accessGroups_wrapper}>{renderParticipationGroups(client)}</div>
            </>
          ) : (
            <>
              Участь в супроводі:
              <div className={styles.withoutAccessGroups_text}>Не не брав участі в супроводі.</div>
            </>
          )}
          <AddClientNotes client={client} />
        </div>
      ) : (
        <div className={styles.content_wrapper}>{loaderPage ? 'Загрузка...' : 'Пусто:)'}</div>
      )}

      {popup && <PopupEditClient client={client} handleClick={setPopup} />}
      {loaderPage && <LoaderPage />}
    </>
  );
}
